// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--FDs93","text":"_93444fe79c--text--pJfKR"};